import mermaid from "https://cdn.jsdelivr.net/npm/mermaid@11/dist/mermaid.esm.min.mjs";
mermaid.initialize({
	startOnLoad: true,
	securityLevel: "loose",
	theme: window.matchMedia("(prefers-color-scheme: dark)").matches ? "dark" : "default"
});